import { Button } from '@/components/ui/button';
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { Text } from '@/components/ui/text';
import { DialogStateManager } from '@/features/dialog/dialog-provider';
import { useLocale } from '@/lib/hooks/use-locale';
import type { RouterOutputs } from '@/utils/api';
import { api } from '@/utils/api';
import { EllipsisVerticalIcon, MailIcon, Trash2Icon } from 'lucide-react';
import { DeleteEventModal } from './delete-event-modal';

interface EventOptionsDropdownProps {
    date: string;
    event: RouterOutputs['platoUser']['query']['events']['getEventById'];
    onDelete?: () => void;
}

export const EventOptionsDropdown = ({ date, event, onDelete }: EventOptionsDropdownProps) => {
    const { t } = useLocale('events');

    const sendInvitation = api.platoUser.command.events.sendEventInvitation.useMutation();

    const handleDeleteClick = () => {
        if (!event?.event_id) return;
        DialogStateManager.show(DeleteEventModal, {
            date,
            event,
            onDeleted: onDelete,
        });
    };

    const handleReceiveInviteClick = () => {
        if (!event?.event_id) return;

        sendInvitation.mutate({
            eventId: event.event_id,
        });
    };

    return (
        <DropdownMenu>
            <DropdownMenuTrigger asChild>
                <Button variant="icon" icon={EllipsisVerticalIcon} />
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end" side="bottom">
                <DropdownMenuItem onSelect={handleReceiveInviteClick}>
                    <MailIcon className="h-4 w-4" />
                    <Text as="span" className="ml-2">
                        {t('events__receive_reminder', { ns: 'events' })}
                    </Text>
                </DropdownMenuItem>
                <DropdownMenuItem onSelect={handleDeleteClick}>
                    <Trash2Icon className="h-4 w-4 text-red-700" />
                    <Text as="span" color="red-600" className="ml-2">
                        {t('events__delete', { ns: 'events' })}
                    </Text>
                </DropdownMenuItem>
            </DropdownMenuContent>
        </DropdownMenu>
    );
};
